import { AbstractBlockFactory } from '../block/AbstractBlockFactory';
import {
    BlockType,
    ChartComponentSettings,
    ComponentSettingsChartMeasureField,
    NewBlockContextType,
} from '@report-content';
import { AssocArray, YNValues } from 'tools/types';

export class BlockFactoryPieChart extends AbstractBlockFactory<ComponentSettingsPieChart> {
    public getNewBlock({
        nextUId,
        nextSortOrder,
        datasetFields,
    }: NewBlockContextType): BlockType<ComponentSettingsPieChart> {
        const uid = 'block_uid_' + nextUId;
        return {
            // TODO:
            component: {
                datasetRendererBlockComponentId: nextUId,
                datasetRendererBlockId: nextUId,
                datasetRendererComponentId: nextUId,
                displayOrder: nextSortOrder,
                internalName: 'chart',
                settings: {
                    uid: uid,
                    internal_name: 'chart',
                    // component_name: 'Pie',
                    groupFilter: { operator: 'AND', rules: [] },
                    dataQueries: {
                        table: {
                            resultFieldAggregations: {},
                            resultFields: [],
                            sort: [],
                        },
                    },
                    measureFields: [],
                    group_field: datasetFields[0].reference_name,
                    title: '',
                    show_title: 'N',
                    height: 600,
                    show_in_viewer: 'Y',
                    is_preview_ind: 'N',
                    include_in_email: 'Y',
                    // is_preview_ind: 'Y',
                    include_in_email_attachment: 'Y',
                    is_collapsed_ind: 'N',
                    localPalette: {},
                    display_value: 'N',
                    display_value_total: 'N',
                    merge_small_sections: 'N',
                    merge_small_limit: 5,
                    system_other_grouping_label: '__system_other_grouping',
                    merge_small_label: 'Other',
                    merge_small_color: '#ed6a6a',
                    // colorFormationRulesData: [
                    // {
                    //     "field_value": "corporate sales",
                    //     "text": "corporate sales",
                    //     "value_position": 3,
                    //     "color": "#4ebe50",
                    //     "defaultColor": "#4ebe50"
                    // },
                    // ],
                    report_no_units_label: 'No exceptions',
                    report_single_unit_label: 'exception',
                    report_multiple_units_label: 'exceptions',
                    isOnCreation: true,
                    drillTo: [],
                },
            },
            // datasetRendererBlockId: number;
            displayOrder: nextSortOrder,
            // elementId: number;
            uid: uid,
        };
    }
}

export interface ComponentSettingsPieChart extends ChartComponentSettings {
    uid: string;
    // component_name: 'Pie';
    measureFields: Array<ComponentSettingsChartMeasureField>;
    group_field: string;
    show_title: YNValues;
    localPalette: AssocArray<string>;
    display_value: YNValues;
    display_value_total: YNValues;
    merge_small_sections: YNValues;
    merge_small_limit: number;
    system_other_grouping_label: string;
    merge_small_label: string;
    merge_small_color: string;
    // colorFormationRulesData: [
    // {
    //     "field_value": "corporate sales",
    //     "text": "corporate sales",
    //     "value_position": 3,
    //     "color": "#4ebe50",
    //     "defaultColor": "#4ebe50"
    // },
    // ],
    report_no_units_label: 'No exceptions';
    report_single_unit_label: 'exception';
    report_multiple_units_label: 'exceptions';
}
